module.exports = __webpack_public_path__ + "img/cute_natural_doodle_6.bc1dd871.png";